module.exports = __webpack_public_path__ + "static/media/video_poster.2f20868d.png";